import environment from "src/utils/environment";
const { isBrowser } = environment;
const path = window.require("path");
const fs = window.require("fs");
const { app } = window.require("@electron/remote");

async function URLFromFiles(files) {
  const promises = files.map((file) =>
    fetch(file).then((response) => response.text())
  );

  const texts = await Promise.all(promises);
  const text = texts.join("");
  const blob = new Blob([text], { type: "application/javascript" });
  return URL.createObjectURL(blob);
}

export default async function addModuleToWorklet(
  aWorklet,
  processorProjectPath
) {
  let processorSource;
  if (!isBrowser) {
    const processorPath = path.join(app.getAppPath(), processorProjectPath);
    processorSource = fs.readFileSync(processorPath, {
      encoding: "utf8"
    });
  } else {
    const urls = await URLFromFiles([`/${processorProjectPath}`]);
    await aWorklet.addModule(urls);
    return () => URL.revokeObjectURL(urls);
  }

  const processorBlob = new Blob([processorSource], {
    type: "text/javascript"
  });
  const processorURL = URL.createObjectURL(processorBlob);

  await aWorklet.addModule(processorURL);

  return () => {
    URL.revokeObjectURL(processorURL);
  };
}
